import { render } from "./ProfilDetailsKontakt.pug?vue&type=template&id=526da05b&lang=pug"
import script from "./ProfilDetailsKontakt.js?vue&type=script&lang=js"
export * from "./ProfilDetailsKontakt.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__